import React from 'react';
import { Checkbox, Input } from 'rsuite';
import LegalPageLayout from 'features/legal/components/LegalPageLayout/LegalPageLayout';
import { CONSENT_LABEL } from 'features/auth/hooks/useBagelSmsConsent';
import classes from './BagelSmsConsentInfo.module.scss';

/**
 * Public evidence page for Twilio A2P campaign review. The real consent form
 * (/bagel-sms-consent) requires staff login before it shows the phone number
 * field, so a reviewer visiting it directly can't see the full experience —
 * this page mirrors the same fields (reusing the real CONSENT_LABEL constant
 * so the two can never drift out of sync) in a static, unauthenticated
 * preview. IMPORTANT: this component is not what Twilio's reviewer actually
 * sees — Rosie is a pure client-side SPA, so a non-JS scraper only gets the
 * CRA <noscript> fallback here. The real evidence is the static HTML written
 * by scripts/prerender-legal-pages.js; keep that in sync with this file.
 */
function BagelSmsConsentInfo() {
  return (
    <LegalPageLayout title="Bagel AI Text Messaging — Opt-In Preview" updatedOn="August 19, 2026">
      <p>
        URBAN TXT staff opt in to Bagel AI text messages through a dedicated consent form on our
        internal staff dashboard. That form requires staff login, so this page shows exactly what
        the opt-in experience looks like for anyone who can&apos;t log in to view it directly.
      </p>

      <div className={classes.preview}>
        <p className={classes.fieldLabel}>Mobile Phone Number</p>
        <Input placeholder="(###) ###-####" disabled size="lg" />

        <div className={classes.consentRow}>
          <Checkbox checked={false} disabled>
            {CONSENT_LABEL}
          </Checkbox>
        </div>
      </div>

      <p>
        The checkbox is unchecked by default. Staff must actively check it and submit the form to
        record consent. No message is sent to that number beforehand, and no other opt-in method
        is used.
      </p>

      <p>
        <a href="/privacy-policy">Privacy Policy</a> | <a href="/terms-and-conditions">Terms &amp; Conditions</a>
      </p>
    </LegalPageLayout>
  );
}

export default BagelSmsConsentInfo;
